import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupName, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { LoginComponent } from 'src/app/modals/login/login.component';
import { PayOptionsComponent } from 'src/app/modals/pay-options/pay-options.component';
import { Departamento } from 'src/app/models/departamento';
import { Municipio } from 'src/app/models/municipio';
import { Product } from 'src/app/models/product';
import { AlertService } from 'src/app/_services/alert.service';
import { DevicesService } from 'src/app/_services/devices.service';
import { FirebaseAuthService } from 'src/app/_services/firebase-auth.service';
import { LoaderService } from 'src/app/_services/loader.service';
import { UserService } from 'src/app/_services/user.service';
import { Order } from '../../../models/order';
import { OrderService } from '../../../_services/order.service';

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss']
})
export class ShoppingCartComponent implements OnInit {

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;

  public shippingAddressForm: FormGroup;
  public couponForm: FormGroup;
  public typeOfPayForm: FormGroup;


  allDepartamentos: Departamento[];
  municipiosPorDepartamento: Municipio[];

  citiesCtrl = new FormControl();
  departamentosCtrl = new FormControl();

  filteredCities: Observable<any[]>;
  filteredDepartamentos: Observable<any[]>;

  allCities: any[];
  order: Order;

  diviceXs: boolean;
  diviceSm: boolean;
  addressComplete: boolean = false;
  stateOfCoupon: boolean = false;
  invalidCouponState:boolean = false;

  shippingCost:number = 8000;
  discountCoupon: number = 1000;


  constructor(public firebaseAuthService: FirebaseAuthService, public userService: UserService,
              private route: ActivatedRoute, private fb: FormBuilder, private matDialog: MatDialog,
    private orderService: OrderService, private devicesService: DevicesService, private alertService: AlertService,
    private loaderService: LoaderService) { }

  ngOnInit(): void {
    this.loadAllDepartamentos();

    this.shippingAddressForm = this.createShippingAddressForm();
    this.couponForm = this.createCouponForm();
    this.typeOfPayForm = this.createTypeOfPayForm();

    this.route.data.subscribe(answ => {
      this.userService.listProductsSession = answ.shoppingCart;
      this.userService.calculateTotals();

    });

    this.devicesService.dievice$.subscribe(res => {
      console.log("device", res)
      this.diviceXs = res === 'xs' ? true : false;
      this.diviceSm = res === 'sm' ? true : false;
    });

  }

  createShippingAddressForm(){
    return this.fb.group({
      // state: ['', Validators.required],
      // city: ['', Validators.required],
      neighborhood: ['', Validators.required],
      address: ['', Validators.required],
      addressSpecification: ['', Validators.required],
    });

  }

  createCouponForm(){
    return this.fb.group({
      discountCoupon: ['', Validators.required]
    });
  }

  createTypeOfPayForm(){
    return this.fb.group({
      type: ['', Validators.required]
    });
  }

  createEditForm(): FormGroup {
    // this.countryId = this.dataUser.countryId;
    // this.regionId = this.dataUser.regionId;
    // this.cityId = this.dataUser.cityId;
    // this.emailOffers = this.user.emailOffers;


    return this.fb.group({
      // address: [this.dataUser.address, Validators.required],


    });

  }

  async updateProductsInShoppingCart(index: number, quantity: number): Promise<void> {

    const product: Product = this.userService.listProductsSession[index];
    product.quantity = quantity;

    if (this.firebaseAuthService.privateProfile) {
      await this.userService.updateProductQuantityOfShoppinCart(product);
    } else {
      this.userService.updateProductQuantityOfShoppinCartInLocalStorage(product);
    }

    this.userService.calculateTotals();
  }

  async removeItem(id: string): Promise<void> {

    try {
      if (this.firebaseAuthService.privateProfile) {
        await this.userService.removeProductFromShoppingCart(id);
        this.userService.listProductsSession = this.firebaseAuthService.privateProfile.shoppingCart;
      } else {
        this.userService.removeProductFromShoppingCartInLocalStorage(id);
        this.userService.listProductsSession = JSON.parse(localStorage.getItem('tugessiShoppingCart'));
      }
    } catch (error) {
      console.log('Error! ');

    }

    this.userService.calculateTotals();
  }

  private _filterDepartamentos(value: string): any[] {
    const filterValue = value.toLowerCase();

    this.focusOutDepartamento(filterValue);
    return this.allDepartamentos.filter(depto => depto.departamento.toLowerCase().indexOf(filterValue) === 0);
  }

  private _filterCities(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.municipiosPorDepartamento.filter(city => city.municipio.toLowerCase().indexOf(filterValue) === 0);
  }

  loadAllDepartamentos() {

    this.userService.getDepartamentos().subscribe(departamentos => {
      this.allDepartamentos = departamentos;
      this.filteredDepartamentos = this.departamentosCtrl.valueChanges
        .pipe(
          startWith(''),
          map(departamento => departamento ? this._filterDepartamentos(departamento) : this.allDepartamentos.slice())
        );
    }, error => {
      console.log(error);
    });
  };

  pay(): void{
    console.log("this.typeOfPayForm.value.type",this.typeOfPayForm.value.type)

    if(this.typeOfPayForm.value.type == "dinero"){
      this.generateOrder('epayco');
    }
    else{

    }

    // const dialogRef = this.matDialog.open(PayOptionsComponent,
    //   {
    //     height: '25%',
    //     width: '25%'
    //   });

    // dialogRef.afterClosed().subscribe(result => {
    //   console.log('Está pagando con:' + result);
    //   if (result) {
    //     this.generateOrder('epayco');
    //   }
    // });
  }

  async generateOrder(paymentMethod: string) {


    this.order = new Order();

    this.order.customerId = this.firebaseAuthService.publicUser.uid;
    this.order.customerEmail = this.firebaseAuthService.publicUser.email;

    this.order.addres = this.shippingAddressForm.get('address').value;
    this.order.cityName = this.citiesCtrl.value;
    this.order.departamento = this.departamentosCtrl.value;
    this.order.neighborhood = this.shippingAddressForm.get('neighborhood').value;
    this.order.addresExtraInformation = this.shippingAddressForm.get('addressSpecification').value;

    this.order.date = new Date();
    this.order.subtotal = this.userService.totalShoppingCartValueToPay;
    this.order.discountTotal = 0;
    this.order.taxesTotal = 0;
    this.order.otherCosts = 0;
    this.order.total = this.userService.totalShoppingCartValueToPay;
    this.order.orderDetail = this.firebaseAuthService.privateProfile.shoppingCart;
    this.order.orderStatus = 'Pendiente';
    this.order.orderStatusId = 3;
    this.order.paymentMethod = paymentMethod;
    // this.order.totalCostInPoints =
    this.order.totalRevenuePoints = this.userService.totalShoppingCartRevenuePoints;
    this.loaderService.isLoading = of(true);
    const answ = await this.orderService.saveOrder(this.order);
    this.loaderService.isLoading = of(false);

    this.order.id = answ.id;

    this.orderService.deployEpaycoCheckout(this.orderService.configEpaycoPayment(this.order));
  }

  showInfo(){
    this.loadAllDepartamentos();
    this.citiesCtrl.disable();
  }

  goToLogIn(): void{
    const dialogRef = this.matDialog.open(LoginComponent, {
      hasBackdrop: true,
      height: '90%'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  registerAddress(){
    console.log("Addres",this.shippingAddressForm);
    this.addressComplete = true;
  }

  editAddress(){
    this.addressComplete = false;
  }

  validateCoupon(){
    if(this.couponForm.value.discountCoupon == "tugessi"){
      this.stateOfCoupon = true;
      this.invalidCouponState = false;
    }
    else{
      this.invalidCouponState = true;
      this.stateOfCoupon = false;
    }

  }

  loadMunicipioByDepartamentoName(name: string) {
    this.userService.getMunicipiosPorDepartamento(name).subscribe(municipios => {
      this.municipiosPorDepartamento = municipios;

      this.filteredCities = this.citiesCtrl.valueChanges
        .pipe(
          startWith(''),
          map(city => city ? this._filterCities(city) : this.municipiosPorDepartamento.slice())
        );
      this.citiesCtrl.enable();

    }, error => {
      console.log(error);
    });
  }

  focusOutDepartamento(value): void {
    const inputDepartamento = value;
    let dept = this.allDepartamentos.find(dept => dept.departamento === inputDepartamento.toString());

    if (!dept) {
      this.resetMunicipio();
    }
  }

  setMunicipio(municipioName): void {
    let city: Municipio = this.municipiosPorDepartamento.find(municipio => municipio.municipio === municipioName);
  }

  resetMunicipio() {
    this.citiesCtrl.reset();
    this.citiesCtrl.disable();
  }

}
